// extracted by mini-css-extract-plugin
module.exports = {"cardIcon":"CardIcon_cardIcon__1Figo"};